import Vue from 'vue'
import Router from 'vue-router'
import i18n from '@/i18n'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('./views/carriers/CarriersLayout.vue'),
      children: [
        {
          path: '',
          name: 'carriers-detail',
          meta: {
            title: 'CARRIERS_DETAIL.TITLE'
          },
          component: () => import('./views/carriers/detail/CarriersDetail.vue'),
        },
        {
          path: 'edit',
          name: 'carriers-edit',
          meta: {
            title: 'CARRIERS_EDIT.TITLE'
          },
          component: () => import('./views/carriers/edit/CarriersEdit.vue'),
        }
      ]
    },
    {
      path: '/rate-requests',
      component: () => import('./views/rate-requests/RateRequestsLayout.vue'),
      children: [
        {
          path: '',
          name: 'rate-requests-list',
          meta: {
            title: 'RATE_REQUESTS_LIST.TITLE'
          },
        }
      ]
    },
    {
      path: '/contracts',
      component: () => import('./views/contracts/ContractsLayout.vue'),
      children: [
        {
          path: '',
          name: 'contracts-list',
          meta: {
            title: 'CONTRACTS_LIST.TITLE'
          },
          component: () => import('./views/contracts/list/ContractsList.vue')
        }
      ]
    },
    {
      path: '**',
      redirectTo: { name: 'carriers-detail' }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const title = i18n.t(to.meta.title)
  const appName = i18n.t('APP.NAME')
  const appCompany = i18n.t('APP.COMPANY')

  document.title = `${title} - ${appName} - ${appCompany}`

  next()
})

export default router
